import gql from 'graphql-tag';

export const postFragmentQuery = `
  fragment PostFragment on Post {
  __typename
    _id
    title
    description
    voteRate
    timeForReading
    isVoted
    isAddedToFavorite
    position
    isPublished
    countOfVotes
    language
    metaKeyWords
    metaDescription
    metaTitle
    alias
    content
    tags {
      name
      alias
      _id
    }
    creator {
      _id
      login
      firstName
      lastName
      email
      phone
      isSubscribedToPosts
      avatar {
        path
        _id
      }

      role
      subscriptions {
        categories
        type
        isUnsubscribed
      }
    }
    image {
      path
    }
    thumbnail {
      path
    }
    videos
    category {
      _id
      name
      alias
    }
    createdAt
  }
`;

export default gql`
  ${postFragmentQuery}
`;
